type Permission =
  | "view_system_setting"
  | "edit_system_setting"
  | "admin_sensitive_data"
  | "view_organisation_setting"
  | "edit_organisation_setting"
  | "view_user"
  | "edit_user"
  | "view_permissions"
  | "edit_permissions"
  | "view_template"
  | "use_template"
  | "edit_template"
  | "view_contact"
  | "sensitive_data"
  | "edit_contact"
  | "view_group"
  | "edit_group"
  | "view_reporting"
  | "export_reporting"
  | "view_inbound_campaign"
  | "use_inbound_campaign"
  | "use_outbound_broadcast"
  | "view_project"
  | "use_project"
  | "edit_project"
  | "edit_production"
  | "view_api"
  | "edit_api"
  | "access_billing"
  | "expert_logic_view"
  | "expert_logic_edit";

const permissions = {
  system_settings: [
    "view_system_setting",
    "edit_system_setting",
    "admin_sensitive_data",
  ],
  organisation_settings: [
    "view_organisation_setting",
    "edit_organisation_setting",
  ],
  users: ["view_user", "edit_user"],
  permissions: ["view_permissions", "edit_permissions"],
  templates: ["view_template", "use_template", "edit_template"],
  contacts: ["view_contact", "sensitive_data", "edit_contact"],
  groups: ["view_group", "edit_group"],
  reporting: ["view_reporting", "export_reporting"],
  message_hub: ["view_message_hub"],
  help: ["edit_help"],
  incident_hub: ["use_incident_hub"],
  inbound_campaign: ["view_inbound_campaign", "use_inbound_campaign"],
  outbound_broadcast: ["use_outbound_broadcast"],
  bypass_departments: ["bypass_message_hub", "bypass_full"],
  projects: ["view_project", "use_project", "edit_project", "edit_production"],
  api: ["view_api", "edit_api"],
  triage: ["use_triage"],
  hierarchy: ["access_subaccounts"],
  billing: ["access_billing"],
};

type PagePropsType = {
  accountEmails: string[];
  emailSuffix: string;
  emailDomain: string;
  csrfToken: string;
  user: {
    name: string;
    firstName: string;
    lastName: string;
    email: string;
    id: number;
    isSuperAdmin: boolean;
    isController: boolean;
    permissions: Permission[];
  };
  globalClientId: number;
  countries: {
    id: number;
    country_code: string;
    country_name: string;
    idd: number;
    mcc: number;
    country: null;
    vat: number;
    currency_iso: string;
    trials_block_after: number;
  }[];
  defaultCountry: any;
  defaultTZ: string;
  logoBaseUrl: string;
  baseUrl: string;
  workflowsBaseUrl: string;
  isSuperadmin: boolean;
  isLocal: boolean;
  customerName: string;
  accountGatewayId: string;
  customerGatewayId: string;
  productName: string;
  contactsClientId: string;
  contactsBaseUrl: string;
  apiBase: string;
  apiToken: string;
  showNewFeatures: boolean;
  workflowsPublicUrl: string;
  nylas: {
    apiServer: string;
    clientId: string;
  };
  inboundApiBase: string;
  addOns: { social_hours: boolean; secure_data: boolean };
  securitySetting?: {
    system_timeout?: number;
    password_change?: number;
    login_attempts?: number;
    two_factors?: "Y" | "N";
    tf_frequency?: string;
    tf_code_attempts?: number;
    tf_expire_minutes?: number;
    force_authenticator?: "Y" | "N";
  };
  configurations: {
    "AI Models": {
      [key: string]: string;
    };
    "Time Zones": {
      [key: string]: string;
    };
  };
  isTrial: boolean;
  trialSource: string | null;
  trialPermissions: Permission[];
};

export const pageProps: PagePropsType = JSON.parse(
  (document as any).querySelector("#app").dataset.page
).props;

export const isUserPermitted = (permission: Permission): boolean =>
  (!pageProps.isTrial &&
    (pageProps.user.isSuperAdmin ||
      pageProps.user.isController ||
      pageProps.user.permissions.includes(permission))) ||
  (pageProps.isTrial && pageProps.trialPermissions.includes(permission));
